import React, { Component } from "react";

class CopyRight extends Component {
  render() {
    return (
      <div className="ltn__copyright-area ltn__copyright-2 section-bg-7  plr--5">
        <div className="container-fluid ltn__border-top-2">
          <div className="row">
            <div className="col-12">
              <div className="ltn__copyright-design clearfix text-center">
                <p>
                  All Rights Reserved @ Aquad Software Solutions Pvt Ltd
                </p>
              </div>
            </div>
      
          </div>
        </div>
      </div>
    );
  }
}

export default CopyRight;
